export const DETAILS = {
  RUN_DATE: 'Run Date:',
  REPORT_TITLE: 'Summary Report',
  BACK: 'Back',
  CLEAR: 'Clear Form',
  DOWNLOAD_CSV: 'Download CSV',
  UPDATE_FEEDBACK_TOAST: 'Feedback for Fintel Check submitted.',
};
